import React from 'react';
import utils from '../../utils';
import config from '../internetConfig';
import metrics from '../internetMetrics';

export default function PodcastResult(props) {
	const result = Object.assign({}, props && props.result);
	const title = result.title || '';
	const description = result.description || '';
	const series = String(result.series || '');
	let transcript = String(result.transcript || '');
	let transcriptFileType = '';
	let ext = transcript.replace(/^.*\./,'').replace(/[\?#].*$/,'').toLowerCase();
	if (ext.length) {
		transcriptFileType = '[' + ext.toUpperCase() + ']';
	}

	const seriesUrl = result.seriesId
		? 'https://tools.cdc.gov/medialibrary/index.aspx#/podcastseries/id/' + result.seriesId
		: '';
	const podcastUrl = result.id ? 'https://tools.cdc.gov/medialibrary/index.aspx#/media/id/' + result.id : '';
	const duration = utils.formatMSS(result.duration || 0);
	const date = utils.formatDate(result.date);

	// We don't have captions for podcasts, or a ready way to display them
	/* eslint-disable jsx-a11y/media-has-caption */
	return (
		<div className="result result-podcast result-card">
			<div className="result-title">
				<a href={podcastUrl} onClick={(e) => metrics.event(e, 'cdcsitesearch-podcasts-link')} dangerouslySetInnerHTML={{ __html: title }}></a>
			</div>
			<div className="result-description" dangerouslySetInnerHTML={{ __html: description }}></div>
			<audio controls="controls">
				<source type="audio/mpeg" src={result.audio} />
				Your browser does not support the audio element.
			</audio>
			<div className="ml-auto d-md-flex result-date" dangerouslySetInnerHTML={{__html: date }}></div>

		</div>
	);
}
